import {
  ConsortiumAlertsSummary,
  ConsortiumAlertsSummaryResponse,
} from 'app/modules/consortium/responses';
import { InvestigationOutcome } from 'app/modules/consortium/responsesV2';
import { isEmpty } from 'lodash';

export const hasConsortiumAlerts = (
  consortiumAlertsSummary: ConsortiumAlertsSummary,
): boolean => {
  return consortiumAlertsSummary.all_time.total_distinct_orgs > 0;
};

export const consortiumAlertsSummaryHasAlerts = (
  consortiumAlertsSummary:
    | ConsortiumAlertsSummaryResponse
    | Record<string, never>
    | undefined,
): consortiumAlertsSummary is ConsortiumAlertsSummaryResponse => {
  if (!consortiumAlertsSummary || isEmpty(consortiumAlertsSummary)) {
    return false;
  }
  return Object.values(consortiumAlertsSummary).some((summary) =>
    hasConsortiumAlerts(summary),
  );
};

const INVESTIGATION_OUTCOME_SEVERITY: Record<InvestigationOutcome, number> = {
  [InvestigationOutcome.BLOCKED]: 3,
  [InvestigationOutcome.ESCALATED]: 3,
  [InvestigationOutcome.CONFIRMED_UNUSUAL]: 3,
  [InvestigationOutcome.UNDER_INVESTIGATION]: 2,
  [InvestigationOutcome.UNDETERMINED]: 2,
  [InvestigationOutcome.FALSE_POSITIVE]: 1,
};

export const getHighestSeverityColor = (outcomes: InvestigationOutcome[]) => {
  if (outcomes.length === 0) {
    return 'success' as const;
  }

  const maxSeverity = Math.max(
    ...outcomes.map((o) => INVESTIGATION_OUTCOME_SEVERITY[o] ?? 0),
  );

  if (maxSeverity >= 3) {
    return 'error' as const;
  }
  if (maxSeverity >= 2) {
    return 'warning' as const;
  }
  return 'success' as const;
};
